module.exports = __webpack_public_path__ + "media/icons/mailing-twitter-e90cdc5b.png";